import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { getStoredUiLang } from '../lib/uiLocale';
import { translateKey } from './messages';

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [locale, setLocaleState] = useState(() => getStoredUiLang());

  useEffect(() => {
    const onLang = (e) => {
      const v = e?.detail;
      if (v === 'ru' || v === 'en' || v === 'es') setLocaleState(v);
    };
    window.addEventListener('mad:uiLang', onLang);
    return () => window.removeEventListener('mad:uiLang', onLang);
  }, []);

  const t = useCallback(
    (key, vars) => translateKey(locale, key, vars),
    [locale]
  );

  const value = useMemo(() => ({ locale, t, setLocale: setLocaleState }), [locale, t]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) {
    throw new Error('useI18n must be used within I18nProvider');
  }
  return ctx;
}

export function useI18nOptional() {
  return useContext(I18nContext);
}
